import { useKeycloak } from '@react-keycloak/web'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { bindActionCreators } from 'redux'
import 'preact/debug'
import dayjs from 'dayjs'

import 'react-toastify/dist/ReactToastify.css'
import AppRouter from './AppRouter'
import './assets/style/app.scss'
import { init_data } from './action/data'
import { get_account } from './action/user'
import Loading from './components/Loading'
import ModalColorPicker from './components/UI/ModalColorPicker'
import { google_client_id } from './config/config'
import { locale_fr } from './constants/locale'
import { updateToken } from './utils/utilsSSO'

const relativeTime = require('dayjs/plugin/relativeTime')
const updateLocale = require('dayjs/plugin/updateLocale')
require('dayjs/locale/fr')
require('dayjs/locale/en')
require('dayjs/locale/it')
require('dayjs/locale/de')
dayjs.extend(relativeTime)
dayjs.extend(updateLocale)
dayjs.updateLocale('fr', { relativeTime: locale_fr })

const App = (props) => {
  const { colorPicker } = props
  const { keycloak, initialized } = useKeycloak()

  useEffect(() => {
    if (props?.auth?.current_locale)
      dayjs.locale(props?.auth?.current_locale.split('_')[0])
  }, [props?.auth?.current_locale])

  useEffect(() => {
    if (initialized) props.init_data(keycloak.token)
  }, [initialized])

  useEffect(() => {
    if (props.auth?.token) props.get_account()
  }, [props.auth?.token])

  if (!initialized || props.auth?.loading_user || props.app.app_loading) {
    return <Loading />
  }

  setInterval(() => updateToken(keycloak, 1000 * 7200), 1000 * 60 * 60)

  return (
    <GoogleOAuthProvider clientId={google_client_id}>
      {colorPicker ? <ModalColorPicker {...colorPicker} /> : null}
      <AppRouter />
      <ToastContainer />
    </GoogleOAuthProvider>
  )
}

const mapStateToProps = (state) => {
  return {
    // data: state.data,
    auth: state.auth,
    app: state.app,
    colorPicker: state.fields?.colorPicker,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators({ init_data, get_account }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
